import React, { Fragment } from 'react'
import { useForm } from 'react-hook-form'
import styled from '@emotion/styled'
import useApi from '../../hooks/use-api'
import Button from '../shared/button'
import { Input, Error } from '../shared/forms'
import Loader from '../shared/loader'

const SignUpButton = styled(Button)`
  width: 100%;
  min-height: 3.75rem;
  cursor: pointer;
`

const Form = styled.form``

const FormInput = styled(Input)`
  margin-bottom: ${p => p.theme.space[3]};
`

const FormError = styled(Error)`
  margin-bottom: ${p => p.theme.space[5]};
`

const RegistrationForm = ({ className, password = true, next }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    clearErrors,
  } = useForm()
  const { registerUser, loading } = useApi()
  const required = 'This field is required'

  const setServerErrors = (errs = {}) =>
    Object.keys(errs).forEach(key =>
      setError(key, {
        type: 'server',
        message: errs[key].join(' '),
      }),
    )

  const handleFormSubmit = evt => {
    clearErrors()
    return handleSubmit(data => {
      return registerUser(data, next).catch(err =>
        setServerErrors(err.field_errors),
      )
    })(evt)
  }

  return (
    <Form className={className} onSubmit={handleFormSubmit}>
      <FormInput
        error={errors.email}
        type="email"
        placeholder="Email"
        {...register('email', { required })}
      />
      {errors.email && <FormError>{errors.email.message}</FormError>}

      {password && (
        <Fragment>
          <FormInput
            error={errors.password}
            type="password"
            placeholder="Password"
            {...register('password', { required })}
          />
          {errors.password && <FormError>{errors.password.message}</FormError>}
        </Fragment>
      )}

      {errors.__all__ && <FormError>{errors.__all__.message}</FormError>}

      <SignUpButton variant="outline">
        {loading ? <Loader /> : 'Sign up with email'}
      </SignUpButton>
    </Form>
  )
}

export default RegistrationForm
